import { adminTypes } from "app/redux/type/adminTypes";

const initialState = {
  isLoading: false,
  adminList: null,
  adminDetail: null,
  msg: "",
};
export const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    case adminTypes.GET_ADMIN_DATA_PENDING:
      return {
        ...state,
        isLoading: action.isLoading,
        msg: "",
      };
    case adminTypes.GET_ADMIN_DATA_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        adminList: action.payload,
        msg: "",
      };
    case adminTypes.GET_ADMIN_DATA_FAILED:
      return {
        ...state,
        isLoading: action.isLoading,
        adminList: action.payload,
        msg: action.msg,
      };
    case adminTypes.GET_ADMIN_DETAIL_PENDING:
      return {
        ...state,
        isLoading: action.isLoading,
        msg: "",
      };
    case adminTypes.GET_ADMIN_DETAIL_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        adminDetail: action.payload,
        msg: "",
      };
    case adminTypes.GET_ADMIN_DETAIL_FAILED:
      return {
        ...state,
        isLoading: action.isLoading,
        adminDetail: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};
